// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UserSchema } from './v1/userSchema';
import { v1UsersCreateSchema } from './v1/users/createSchema';

export const updateUserPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  id: z.number().int().describe("User id"),
});

export const updateUserHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description user updated
 */
export const updateUser200Schema = z.lazy(() => v1UserSchema);

export const updateUserMutationRequestSchema = z.lazy(() => v1UsersCreateSchema);

export const updateUserMutationResponseSchema = z.lazy(() => updateUser200Schema);
